import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import * as actions from '../../actions';
import { isRequiredQuestionSelection } from '../helpers/Validation';
import dividerSvg from '../../divider.svg';
import brokenHeartSvg from '../../assets/images/drp-delusions-of-jealousy.svg';

class Step4 extends Component {
    render() {
        const { falseBeliefs, userType } = this.props.questionOptions;
        return (
            <Fragment>
                <img src={brokenHeartSvg} className="overlay-image" />
                <div className="form-group">
                    <div className="grid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="h1">
                                    {userType === "caregiver" ? 
                                        "Has your loved one believed things that aren't true (delusions)?"
                                        : "Have you believed things, which your loved one tells you aren't true (delusions)?"
                                    }
                                </h1>
                                <img src={dividerSvg} alt="divider" />
                                <Field className="form-control full-width-input" defaultValue={falseBeliefs} name="falseBeliefs" component="input" type="hidden" validate={isRequiredQuestionSelection}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <button
                                            className={"btn btn-primary btn-lg w-auto text-center wide-mobile "  + (falseBeliefs === "yes" ? "active" : "")}
                                            type="submit"
                                            onClick={(e) => this.props.questionAnswer("falseBeliefs", "yes")}
                                        >
                                            <b>Yes</b>
                                        </button>
                                        <button
                                            className={"btn btn-primary btn-lg w-auto text-center wide-mobile "  + (falseBeliefs === "no" ? "active" : "")}
                                            type="submit"
                                            onClick={(e) => this.props.questionAnswer("falseBeliefs", "no")}
                                        >
                                            <b>No</b>
                                        </button>
                                        <button
                                            className={"btn btn-primary btn-lg w-auto text-center wide-mobile "  + (falseBeliefs === "I do not know" ? "active" : "")}
                                            type="submit"
                                            onClick={(e) => this.props.questionAnswer("falseBeliefs", "I do not know")}
                                        >
                                            <b>I do not know</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(Step4);